/**
 * Constants for Best Available Seating feature
 */

/**
 * The height of the best available seating slide drawer on mobile as a percentage of viewport height.
 * Used in both the slide component and parent containers to calculate available space.
 * Value: 0.5 represents 50% of viewport height (50vh)
 */
export const BEST_AVAILABLE_SLIDE_HEIGHT_PERCENT = 0.5;
